import { ChangeDetectorRef, Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { TinymceService } from '../tinymce.service';
import { NzMessageService } from 'ng-zorro-antd/message';
@Component({
    selector: 'clink-select-image-modal',
    templateUrl: './select-image-modal.component.html',
    styleUrls: ['select-image-modal.component.less'],
})
export class SelectImageModalComponent implements OnInit {
    static config = {
        nzContent: SelectImageModalComponent,
        nzMaskClosable: false,
        nzWidth: 835,
        nzFooter: null,
        nzComponentParams: {
            data: {},
        },
    };
    limit = 100; // 最多可选择的图片数
    finalSelects: any = []; // 最终选择的图片，数据库 or uploader 上传的
    url;
    tabLinks: any = [
        {
            label: '我的图片',
            type: 'tabMaterial',
        },
        {
            label: '本地上传',
            type: 'tabUpload',
        },
    ];
    activeTab = this.tabLinks[0];
    // 本地图片
    pageConfig: any = {};
    params: any = {};
    // fileList: any = []
    loading = false;
    selectedFiles: any = []; // 选择数据库中的图片

    // upload
    uploader: FileUploader;
    uploadDatas: any = []; // 读取uploader.queue中的图片数据，用以显示图片
    num = 0;
    @Input() data;

    constructor(
        public modalRef: NzModalRef<SelectImageModalComponent>,
        private detector: ChangeDetectorRef,
        private tinymceService: TinymceService,
        private message: NzMessageService,
        private modal: NzModalService,
    ) {}

    ngOnInit(): void {
        if (!this.limit) {
            this.limit = 100;
        }
        const options: FileUploaderOptions = {
            url: this.data.uploadUrl, // 上传地址--string
            method: 'POST', // 上传文件的方式--string
            itemAlias: this.data.file, // 文件标记、别名--string
            // authTokenHeader: 'Authorization', // auth验证token的请求头--string
            headers: [{ name: 'accept', value: 'application/json' }], // 上传文件的请求头参数--Array<headers>
            removeAfterUpload: true, // 是否在上传完成后从队列中移除--boolean
            // maxFileSize: 2 * 1024 * 1024 // 最大可上传文件的大小--number
        };
        this.uploader = new FileUploader(options);
        // this.uploader = this.uploaderService.getFileUploader(this.data.uploadUrl, this.data.file, { removeAfterUpload: false });
        this.initParams();
        // this.reload()
        this.uploader.onAfterAddingFile = (e) => {
        };
    }

    onActiveChange(event): void {
        this.activeTab = this.tabLinks[event];
    }

    // 点击关闭，取消上传，清空uploader queue
    onCloseDialog(): void {
        this.uploader.cancelAll();
        this.uploader.clearQueue();
        this.modalRef.close();
    }

    // files
    initParams(): void {
        this.params = { $skip: 0, $limit: 21, $sort: { createdAt: -1 }, contentType: '/image/*/' };
        this.pageConfig = { currentPage: 1, totalItems: 0, limit: this.params.$limit };
    }

    /**
     * @desc 点击file item
     */
    toggleSelectFile(item): void {
        const { _id } = item;
        const _index = this.selectedFiles.findIndex((it) => it._id === _id);
        if (_index > -1) {
            this.selectedFiles.splice(_index, 1);
        } else {
            // const {limit} = this.data
            if (this.limit === 1) {
                // 永远选择最新的图片
                this.selectedFiles.length = 0;
                this.selectedFiles.push(item);
            } else {
                if (this.selectedFiles.length < this.limit) {
                    this.selectedFiles.push(item);
                } else {
                    this.message.warning(`您最多只能选择${this.limit}张图片`);
                }
            }
        }
    }

    /**
     * @desc 获取已选中的select index
     */
    getSelectedIndex(itemId): number {
        return this.selectedFiles.findIndex((it) => it._id === itemId) - -1;
    }

    /**
     * @desc 保存已选择的服务器中图片
     */
    onSaveMaterials(): void {
        this.finalSelects.splice(0, this.finalSelects.length);
        this.finalSelects.push(...this.selectedFiles);
    }

    // upload
    selectedFileOnChanged(event): void {
        const files = event.target.files;
        const { queue } = this.uploader;
        if (queue && queue.length > 0) {
            let num = 0;
            queue.forEach((item, index) => {
                if (item.file) {
                    if (!this.tinymceService.isValidFile(item.file, false)) {
                        this.message.warning('图片大小超过限制！');
                        queue.splice(index, 1);
                        num -= -1;
                    }
                }
            });
            if (num > 0) {
                this.modal.warning({
                    nzTitle: `已自动为您过滤掉${num}张不符合图片格式的文件`,
                    nzContent: '',
                    nzOkText: '确定',
                    nzOkType: 'primary',
                    nzCancelText: '取消',
                });
            }
            // balance 超过的图片数
            const balance = queue.length - this.limit;
            if (balance > 0) {
                queue.splice(-balance, balance);
                this.modal.warning({
                    nzTitle: `已自动为您过滤掉超过${balance}张的图片`,
                    nzContent: '',
                    nzOkText: '确定',
                    nzOkType: 'primary',
                    nzCancelText: '取消',
                });
            }

            // 读取queue中的文件数据，显示图片
            const list = [];
            queue.forEach((val, i, array) => {
                const fileReader = new FileReader();
                fileReader.onloadend = (e) => {
                    const imageData = fileReader.result;
                    list.push(imageData);
                };
                fileReader.readAsDataURL(val._file);
            });
            this.uploadDatas = list;
        }
    }

    removeUploadFile(index): void {
        const { queue } = this.uploader,
            len = queue.length;
        if (len === this.uploadDatas.length && len > index) {
            queue.splice(index, 1);
            this.uploadDatas.splice(index, 1);
        } else {
        }
    }

    uploadAllFiles(): void {
        const { queue } = this.uploader;
        const self = this;
        const list = [];
        // this.uploadFiles.length = 0
        if (queue) {
            const balance = queue.length - this.limit;
            if (balance > 0) {
                queue.splice(-balance, balance);
                this.modal.warning({
                    nzTitle: `已自动为您过滤掉超过${balance}张的图片`,
                    nzContent: '',
                    nzOkText: '确定',
                    nzOkType: 'primary',
                    nzCancelText: '取消',
                });
            }
            this.uploader.onSuccessItem = (item, response, status, headers) => {
                if (status >= 200 && status < 300) {
                    // 上传文件后获取服务器返回的数据
                    if (list.length < self.limit) {
                        const tempRes = JSON.parse(response);
                        list.push(tempRes);
                    }
                } else {
                    // 上传文件后获取服务器返回的数据错误
                    this.message.error('图片上传失败');
                }
            };
            this.uploader.onErrorItem = (item, response, status, headers) => {
                // 上传文件后获取服务器返回的数据错误
                self.message.error('图片上传失败, 请检查网络是否连接');
            };
            this.uploader.uploadAll(); // 开始上传
        }
        this.uploader.onWhenAddingFileFailed = (item, filter) => {
            this.message.error('图片上传失败，请检查网络是否连接');
        };
        this.uploader.onProgressAll = (progress: any) => {
            this.detector.detectChanges();
        };
        this.uploader.onCompleteAll = () => {
            // 关闭 modal
            this.finalSelects.splice(0, this.finalSelects.length);
            this.finalSelects.push(...list);
            this.modalRef.close(this.finalSelects);
        };
    }
}
